import { CodingExamStatics } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { CodeBlock, dracula } from 'react-code-blocks';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    ChevronUpIcon,
    EmptyStateIcon,
    ChevronDownIcon,
} from '../../../../../assets/icons';

interface Props {
    jobTitle: string;
    examData: CodingExamStatics | null;
}

export default function CodingExamSheet(props: Props) {
    const { jobTitle, examData } = props;
    const [selectedLang, setSelectedLang] = useState('');
    const [openedaAcordions, setOpenedaAcordions] = useState<number[]>([]);
    const search = examData?.exam?.questions.find(i => selectedLang in i);
    const question = search ? search[selectedLang] : [];

    useEffect(() => {
        const lang = examData ? examData.exam.languages[0] : '';
        setSelectedLang(lang);
    }, [examData]);

    const manageAcordions = (index: number) => {
        const check = openedaAcordions.findIndex(i => i === index);
        if (check === -1) {
            setOpenedaAcordions(prev => [...prev, index]);
        } else {
            setOpenedaAcordions(prev => prev.filter(i => i !== index));
        }
    };

    return (
        <MotionWrapper className={styles.container}>
            {!examData ?
                <div className={styles.empty_state}>
                    <EmptyStateIcon />
                    <span>No data.</span>
                </div> :
                <div className={styles.detail}>
                    <div className={styles.header}>
                        <div className={styles.header_top}>
                            <span className={styles.header_top_title}>
                                {jobTitle}
                            </span>
                        </div>
                        <div className={styles.header_bottom}>
                            <span className={styles.header_bottom_item}>
                                Question Quantities : {examData.exam.countQuestions}
                            </span>
                            <span className={styles.header_bottom_item}>
                                Exam Time : {examData.exam.time}'
                            </span>
                            <span className={styles.header_bottom_item}>
                                Coding Languages : {examData.exam.languages.map(i => <span
                                    onClick={() => setSelectedLang(i)}
                                    className={styles.header_bottom_item_lang}
                                    data-is-selected={selectedLang === i}
                                >{i}</span>)}
                            </span>
                        </div>
                    </div>
                    <div className={styles.question_data}>
                        <span>Question 1:</span>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(0)}
                            >
                                <span>Description</span>
                                {openedaAcordions.some(i => i === 0) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 0) &&
                                <pre className={styles.accordion_body}>
                                    {question[0]?.description}
                                </pre>}
                        </div>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(6)}
                            >
                                <span>Test Cases:</span>
                                {openedaAcordions.some(i => i === 6) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 6) &&
                                <div className={styles.accordion_body}>
                                    <CodeBlock
                                        text={question[0]?.test_cases}
                                        language={examData.exam.languages[0]}
                                        showLineNumbers={true}
                                        theme={dracula}
                                    />
                                </div>}
                        </div>
                    </div>
                    <div className={styles.question_data}>
                        <span>Question 2:</span>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(2)}
                            >
                                <span>Description</span>
                                {openedaAcordions.some(i => i === 2) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 2) &&
                                <pre className={styles.accordion_body}>
                                    {question[1]?.description}
                                </pre>}
                        </div>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(7)}
                            >
                                <span>Test Cases:</span>
                                {openedaAcordions.some(i => i === 7) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 7) &&
                                <div className={styles.accordion_body}>
                                    <CodeBlock
                                        text={question[1]?.test_cases}
                                        language={examData.exam.languages[0]}
                                        showLineNumbers={true}
                                        theme={dracula}
                                    />
                                </div>}
                        </div>
                    </div>
                    <div className={styles.question_data}>
                        <span>Question 3:</span>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(4)}
                            >
                                <span>Description</span>
                                {openedaAcordions.some(i => i === 4) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 4) &&
                                <pre className={styles.accordion_body}>
                                    {question[2]?.description}
                                </pre>}
                        </div>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(8)}
                            >
                                <span>Test Cases:</span>
                                {openedaAcordions.some(i => i === 8) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedaAcordions.some(i => i === 8) &&
                                <div className={styles.accordion_body}>
                                    <CodeBlock
                                        text={question[2]?.test_cases}
                                        language={examData.exam.languages[0]}
                                        showLineNumbers={true}
                                        theme={dracula}
                                    />
                                </div>}
                        </div>
                    </div>
                </div>}
        </MotionWrapper>
    )
};
